import type { ComponentType } from 'react';
import {
  AdminDashboard,
  AllDevices,
  ManagerDashboard,
  MaintenanceSchedule,
  NewDevice,
} from './screens';

/**
 * Which component serves each `/devices/:role/:section` route.
 *
 * Keys match the nav item keys in src/app/navigation.ts. The admin's `all-users`,
 * `roles` and `settings` screens are Phase 8 — they are the shared administration
 * screens, not devices-specific ones — so they still fall through to the
 * placeholder.
 */
export const DEVICES_SCREENS: Record<string, Record<string, ComponentType>> = {
  secretary: {
    'all-devices': AllDevices,
    'new-device': NewDevice,
    'maintenance-schedule': MaintenanceSchedule,
  },
  manager: {
    dashboard: ManagerDashboard,
  },
  admin: {
    dashboard: AdminDashboard,
    'all-devices': AllDevices,
  },
};
